"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createModel = createModel;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _isLoading = function isLoading(state) {
  return state.get('loading') === true;
};

var _isErrored = function isErrored(state) {
  return state.get('error') === true;
};

var _getErrorStatus = function getErrorStatus(state) {
  return state.get('errorStatus');
};

var _getErrorType = function getErrorType(state) {
  return state.get('errorType');
};

var _getErrorTokens = function getErrorTokens(state) {
  return state.get('errorTokens');
};

var _isDirty = function isDirty(state) {
  return state.get('dirty') === true;
};

var _hasEverLoaded = function hasEverLoaded(state) {
  return state.get('lastLoaded') !== null;
};

var _getData = function getData(state) {
  return state.get('data');
};

var internalStateRecord = (0, _immutable.Record)({
  lastLoaded: null,
  loading: false,
  error: false,
  errorStatus: null,
  errorType: null,
  errorTokens: null,
  dirty: false,
  data: (0, _immutable.Map)({})
});
var modelDefaults = {
  _internalState: null
};

var ModelRecord =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(ModelRecord, _Record);

  function ModelRecord() {
    (0, _classCallCheck2.default)(this, ModelRecord);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ModelRecord).apply(this, arguments));
  }

  (0, _createClass2.default)(ModelRecord, [{
    key: "isLoading",
    value: function isLoading() {
      return _isLoading(this._internalState);
    }
  }, {
    key: "isErrored",
    value: function isErrored() {
      return _isErrored(this._internalState);
    }
  }, {
    key: "getErrorStatus",
    value: function getErrorStatus() {
      return _getErrorStatus(this._internalState);
    }
  }, {
    key: "getErrorType",
    value: function getErrorType() {
      return _getErrorType(this._internalState);
    }
  }, {
    key: "getErrorTokens",
    value: function getErrorTokens() {
      return _getErrorTokens(this._internalState);
    }
  }, {
    key: "errorTokens",
    value: function errorTokens() {
      return _getErrorTokens(this._internalState);
    }
  }, {
    key: "isDirty",
    value: function isDirty() {
      return _isDirty(this._internalState);
    }
  }, {
    key: "hasEverLoaded",
    value: function hasEverLoaded() {
      return _hasEverLoaded(this._internalState);
    }
  }, {
    key: "getData",
    value: function getData() {
      return _getData(this._internalState);
    }
  }], [{
    key: "from",
    value: function from(json) {
      return new ModelRecord(json);
    }
  }]);
  return ModelRecord;
}((0, _immutable.Record)(modelDefaults));

function createModel(state) {
  return ModelRecord.from({
    _internalState: internalStateRecord(state)
  });
}